import { AxiosError } from "axios";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { IBenefitImplementation } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import api from "service/api";
import { useInvalidateBenefitImplementations } from "./useGetBenefitImplementations";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag?: number | string;
  payload: IBenefitImplementation;
};

const updateBenefitImplementation = async ({
  countryCode,
  benefitCategoryTag,
  clientInternalNumberGOS,
  benefitImplementationTag,
  payload,
}: Params): Promise<IBenefitImplementation> => {
  const response = await api.patch(
    `/benefitimplementation/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${benefitImplementationTag}`,
    {
      ...payload,
    }
  );

  return response.data as IBenefitImplementation;
};

export function useUpdateBenefitImplementation(refetch = true) {
  const queryClient = useQueryClient();
  const invalidateBenefitImplementations =
    useInvalidateBenefitImplementations();

  return useMutation(updateBenefitImplementation, {
    mutationKey: MUTATION_KEYS.updateBenefitImplementation,
    onSuccess: (updatedImplementation, variables) => {
      queryClient.setQueryData(
        [
          QUERY_KEYS.benefitImplementation,
          variables.countryCode?.toString(),
          variables.clientInternalNumberGOS?.toString(),
          variables.benefitCategoryTag?.toString(),
          variables.benefitImplementationTag?.toString(),
        ],
        updatedImplementation
      );
      if (refetch) {
        invalidateBenefitImplementations();
      }
    },
    onError: (error: AxiosError) => {
      toast.error(error?.message);
    },
  });
}
